export default function pagingMap(paging) {
    return {
        perPage: +paging.perPage,
        nextPage: +paging.nextPage,
        page: +paging.page,
        totalPages: +paging.totalPages,
        totalRecords: +paging.totalRecords
    }
}
